const communicationsDashboardPageRootUrl = '/dashboard';

export const communicationsDashboardPageUrl = `${communicationsDashboardPageRootUrl}/comms-activity`;
export const communicationsDashboardFeaturedConversationsUrl = `${communicationsDashboardPageRootUrl}/comms-activity/featured-conversations`;
export const communicationsDashboardDigitalSafetyPageUrl = `${communicationsDashboardPageRootUrl}/digital-safety`;
export const communicationsDashboardLeadersAndAudiencesPageUrl = `${communicationsDashboardPageRootUrl}/leaders-and-audiences`;
export const communicationsDashboardLeadersActivityLogPageUrl = `${communicationsDashboardPageRootUrl}/leaders-and-audiences/activity-log`;
